import React from 'react'

const InterestingPart = ({ data }) => {
    return (
        <div>
            <p className="paragraph">{data?.text}</p>
            {data?.paragraph?.map((item, index) => {
                return (
                    <div key={index} className='mb-3'>
                        <p className="paragraph m-0">{item?.para}<b>{item?.paraBold}</b></p>
                        {item?.question && <p className="paragraph m-0">{item?.question?.text}<b>{item?.question?.text1}</b></p>}
                    </div>
                )
            })}
            <div>
                {data?.listing?.length > 0 && (
                    data.listing.map((li, liIndex) => {
                        return (<div key={liIndex}>
                            <h4 className="heading">{li?.heading}</h4>
                            {li?.paragraph?.map((para, paraIndex) => {
                                return <div key={paraIndex}>
                                    <p className="paragraph m-0">{para?.para} <b>{para?.paraBold}</b>{para?.para1}</p>
                                    <ul className="mt-3 page-custom-made-application-list">
                                        {para?.listData?.map((para, paraIndex) => (
                                            <li key={paraIndex}>
                                                {para?.text && <p className="paragraph m-0">{para?.text} </p>}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            })}
                            {li?.Example && (
                                <div>
                                    <h5 className="heading">{li?.Example?.heading}</h5>
                                    {li?.Example?.paragraph?.map((ex, exIndex) => {
                                        return (
                                            <p key={exIndex} className='paragraph'>{ex?.para} <b>{ex?.paraBold}</b></p>
                                        )
                                    })}
                                </div>
                            )}
                        </div>)
                    })
                )}
            </div>
        </div>
    )
}
export default InterestingPart
